let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9DPul"), load("ffEVr"), load("9PQvE")]).then(() => parcelRequire('4rZmd'));